import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export interface TasksListCriteria {
  parentCompanyId: string;
  companyId: string;
  jobTitles: string[];
}

export interface TasksListSearchState {
  criteria: TasksListCriteria;
  hasSearched: boolean;
}

export const defaultTasksListCriteria: TasksListCriteria = {
  parentCompanyId: "",
  companyId: "",
  jobTitles: [],
};

export const defaultTasksListSearchState: TasksListSearchState = {
  criteria: defaultTasksListCriteria,
  hasSearched: false,
};

export const tasksListSearchAtom = atom<TasksListSearchState>({
  key: RecoilKeys.TasksListSearch,
  default: defaultTasksListSearchState,
});
